<template>
		<div>
			<v-row>
				<v-col cols-12 class="text-center text-uppercase">
					<h1>Dados do Evento</h1>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols-6 class="text-center">
					<v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span class="font-weight-medium">Código: </span> {{evento.id}} 
                                <br />
                                <span class="font-weight-medium">Data: </span> {{evento.data_evento}}
                                <br />
                                <span class="font-weight-medium">Local: </span> {{evento.descricao_local}}
                                <br />
                                <span class="font-weight-medium">Título: </span> {{evento.titulo}}
                                <br />
                                <span class="font-weight-medium">Horário: </span> {{evento.inicio}}
                                <br />
                                <span class="font-weight-medium">Grau: </span> {{evento.grau}}º
                                <br />
                                <span class="font-weight-medium">Observação: </span> {{evento.observacao}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols-12 class="text-center"><h2>Doações</h2></v-col>
			</v-row>
			<div class="row" v-if="doacoes.length > 0">
				<div class="col-12">
					<ul class="list-group">
						<li class="list-group-item" v-for="item in doacoes" :key="item.id">
							<span class="tituloDoacao">{{retornaTitulo(item)}}</span>

							<table class="confirmacao mb-4">
								<tr>
									<th>Iniciado</th>
									<th>Clã</th>
									<th>Doação</th>
								</tr>
								<tr v-for="d in item.doacao" :key="d.id">
									<td>{{d.nome_iniciado}}</td>
									<td>{{d.nome_cla}}</td>
									<td>{{d.qtd_doacao}}</td>
								</tr>
							</table>
						</li>
					</ul>
				</div>
			</div>
			<div v-else class="text-center">
				<h2>Não foi solicitado itens para doação!</h2>
			</div>
		</div>
</template>

<script>
	export default{
		name: "ListaParticipantes",
		props: ['evento', 'doacoes'],
		computed: {
			
		},
		methods:{
			retornaUnidade(q, u){
				return q > 1 ? u + 's' : u
			},

			retornaTitulo(item){
				//return t - d == 0 ? 'A quantidade total desse item foi doada' : "Ainda falta " + t - d + " " + u + " para ser doado." 
				let texto = item.qtd_total + ' ' + item.unidade 
				//let pendente = item.qtd_total - item.doacao.qtd_doacao
				let pendente = 0
				let doacaoTotal = 0

				item.doacao.forEach((value)=>{
					doacaoTotal += parseInt(value.qtd_doacao)
				})

				pendente = item.qtd_total - doacaoTotal

				if(item.qtd_total > 1){
					texto += 's de '
				}else{
					texto += ' de '
				}

				texto += ' ' + item.nome_item + ','

				if((pendente) == 0){
					texto += ' doação completa.'
				}else if(pendente == 1){
					texto += ' ainda falta ' + pendente + ' ' + item.unidade + ' para ser doado.'
				}else{
					texto += ' ainda faltam ' + pendente + ' ' + item.unidade + 's para serem doados.'
				}
				return texto
			}
		},
		created(){
			
		}
	}
</script>
<style scoped>


	div.tabelas{
		width: 100%;
		background-color: white;
		padding: 10px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		max-height: 70vh;
	}

	#tabela{
		display: block;
		width: 90%;
		text-align: center;
		border-collapse: collapse;
		border: 1px solid black;
		padding: 8px;
		margin: 0 auto;
	}

	#tabela tr{
		width: 100%;
		border: 1px solid black;
	}

	#tabela tr td{
		width: 50%;
		text-align: left;
		padding-left: 10px;
	}

	table.confirmacao{
		width: 100%;
		text-align: center;
		border-collapse: collapse;
		border: 1px solid black;
		padding: 8px;
		margin: 0 auto;
	}

	table.confirmacao tr{
		width: 100%;
		border-collapse: collapse;
		border: 1px solid black;
	}

	table.confirmacao tr th{
		font-size: 14px;
		border-collapse: collapse;
		border: 1px solid black;
	}
	table.confirmacao tr td{
		width: 20%;
		font-size: 12px;
		border-collapse: collapse;
		border: 1px solid black;
	}


	.ultimaLinha{
		text-align: left;
	}

	.linhaEmBranco{
		color: white;
	}

	.dadosRelatorio{
		font-weight: 300;
		font-size: 8px;
	}

	table.confirmacao .titulo, table.dados .titulo{
		font-size: 18px;
	}
</style>